import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode, EffectFade } from 'swiper/modules';
import { initBg, loadBgNow } from './bg';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';


// ----------------------------------
// -------- SWIPER ------------------
// ----------------------------------


/**
 * Inject the <img> tag into a slide that uses data-lazy-src (slides 2+).
 * Once injected, loadBgNow() applies the background immediately — no
 * IntersectionObserver needed since the slide is already in view.
 */
function injectLazySlide(slideEl) {
    if (!slideEl) return;

    // Swiper loop mode duplicates slides — also handle the original slide.
    const targets = [slideEl];
    const originalIndex = slideEl.dataset.swiperSlideIndex;
    if (originalIndex !== undefined) {
        // Find any clones that share the same original index.
        document.querySelectorAll(`.swiper-slide[data-swiper-slide-index="${originalIndex}"]`).forEach(el => {
            if (!targets.includes(el)) targets.push(el);
        });
    }

    targets.forEach(el => {
        const bg = el.querySelector('.bg[data-lazy-src]');
        if (!bg) return; // already injected or not a lazy slide

        const src = bg.dataset.lazySrc;
        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.decoding = 'async';
        img.loading = 'eager'; // it's in view now, fetch immediately
        // Insert before the filter div so z-index stacking matches slide 1.
        bg.insertBefore(img, bg.firstChild);
        delete bg.dataset.lazySrc; // prevent double-injection

        // bg.js expects an <img data-src> OR applies style directly —
        // use loadBgNow() to set background-image right away.
        loadBgNow(bg, src);
    });
}

export function initSwiper() {


    // Inicializar Swiper con autoplay, loop, freeMode, y navegación
    const swiperMain = new Swiper('.swiper', {
        modules: [Navigation, Pagination, Autoplay, FreeMode, EffectFade],
        spaceBetween: 0,
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: true,
        },
        on: {
            // loop:true clones slides AFTER init — re-observe so bg.js catches them.
            // Slide 1 already has a real <img src>, so initBg only matters for clones.
            init() { initBg(this.el); },

            // When the user navigates to a slide, inject the <img> if not yet done.
            // activeIndex = position in this.slides (includes clones); realIndex = original index.
            slideChange() { injectLazySlide(this.slides[this.activeIndex]); },
        },
    });



}
